import { IHeaderParams } from "@ag-grid-enterprise/all-modules";
import { TimezonePicker } from "@blueprintjs/timezone";
import React, { useState, useCallback, useContext, useEffect } from "react";
import TimeZonePickerTarget from "./TimeZonePickerTarget";
import { DateRangeFilterContext, TimeZoneContext } from "utils/context";
import "./TimeZonePicker.scss";
import RequestTimeRange from "components/RequestTimeRange";

export default function ({ displayName, column, progressSort, api }: IHeaderParams) {
    const [timeZone, setTimeZone] = useContext(TimeZoneContext);
    const [sort, setSort] = useState<string | null>(column.getSort());
    const [filterRange] = useContext(DateRangeFilterContext);
    const [isFilter, setIsFilter] = useState(false);

    useEffect(() => {
        const [from, to] = filterRange;
        setIsFilter(!!from || !!to);
    }, [filterRange]);

    const onSortChanged = useCallback(() => {
        setSort(column.getSort());
    }, [column]);

    useEffect(() => {
        api.addEventListener("sortChanged", onSortChanged);
    }, []);

    const handleClick = useCallback(
        (e) => {
            progressSort(e.shiftKey);
        },
        [progressSort]
    );

    return (
        <div className="ag-cell-label-container ag-header-cell-sorted" onClick={handleClick}>
            <span
                className="ag-header-icon ag-header-cell-menu-button ag-header-menu-always-show"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="actions">
                    <TimezonePicker
                        value={timeZone}
                        onChange={(t) => setTimeZone(t)}
                        popoverProps={{ minimal: true, popoverClassName: "custom-select" }}
                    >
                        <TimeZonePickerTarget />
                    </TimezonePicker>
                    <RequestTimeRange />
                </div>
            </span>

            <div className="ag-header-cell-label ">
                <span className="ag-header-cell-text">{displayName}</span>
                <span className="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true">
                    <span className={`ag-icon ag-icon-filter ${isFilter ? null : "ag-hidden"} `}></span>
                </span>
                <span className={`ag-header-icon ag-header-label-icon ag-sort-icon`}>
                    <span className={`ag-icon ag-icon-${sort} ${sort === "none" ? "ag-hidden" : undefined}`}></span>
                </span>
            </div>
        </div>
    );
}
